import React from 'react';

import cn from 'classnames';

import st from './TimelineTrack.module.sass';
import type { TimelineTrackProps, TimecodeSegmentProps } from './types';

function TimecodeSegment({ segment, onClick = undefined }: TimecodeSegmentProps): React.JSX.Element {
  const isInteractive = Boolean(onClick);
  const {
    startTime, endTime, status, mediaDuration,
  } = segment;

  const segmentWidth = ((endTime - startTime) / mediaDuration) * 100;
  const segmentLeft = (startTime / mediaDuration) * 100;

  const interactiveProps = isInteractive ? {
    role: 'button',
    tabIndex: 0,
    onClick: () => onClick?.(segment),
  } : {};

  return (
    <div
      className={cn(st.Segment, st[`Segment_${status}`])}
      style={{ width: `${segmentWidth}%`, left: `${segmentLeft}%`, cursor: onClick ? 'pointer' : 'default' }}
      {...interactiveProps}
    />
  );
}

function TimelineTrack({
  title,
  segments,
  onSegmentClick = undefined,
}: TimelineTrackProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <div className={st.Title}>{title}</div>

      <div className={st.SegmentsContainer}>
        {segments.map((s) => (
          <TimecodeSegment
            key={`${s.startTime}-${s.endTime}-${s.status}`}
            onClick={onSegmentClick}
            segment={s}
          />
        ))}
      </div>
    </div>
  );
}

export default TimelineTrack;
